/* eslint-disable check-file/filename-naming-convention -- index.ts does not follow the usual naming convention */
import {
  getIllustrationIcon,
  IllustrationName,
} from "@/ui/theme/icons/illustrations/groupClasses/IllustrationDefinitions";
import type { GetIllustrationIconProps } from "@/ui/theme/icons/illustrations/groupClasses/IllustrationDefinitions";

export { getIllustrationIcon, IllustrationName };

export type { GetIllustrationIconProps };
